import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { requestPasswordReset } from "../utils/fetchFunctions";
import Button from "../components/Button";
import InputField from "../components/InputField";
import FormError from "../components/FormError";
import FormContainer from "../components/FormContainer";
import "./auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await requestPasswordReset(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Error requesting password reset");
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <main className="auth-page">
        <FormContainer>
          <header>
            <h1 className="auth-title">Email sent</h1>
          </header>

          <div className="register-success-container">
            <div className="register-success-icon">✉️</div>
            <p className="register-success-text-primary">
              If an account with the email address <strong>{email}</strong>{" "}
              exists, a password reset link has been sent.
            </p>
            <p className="register-success-text-secondary">
              Please check your inbox and click on the link to reset your password.
            </p>
            <Button
              className="auth-button"
              onClick={() => navigate("/login")}
            >
              To Login
            </Button>
          </div>

          <footer className="auth-footer">
            Didn't receive an email?{" "}
            <a
              href="/forgot-password"
              onClick={(e) => {
                e.preventDefault();
                setSuccess(false);
                setEmail("");
              }}
            >
              Request again
            </a>
          </footer>
        </FormContainer>
      </main>
    );
  }

  return (
    <main className="auth-page">
      <FormContainer>
        <header>
          <h1 className="auth-title">Forgot password?</h1>
          <p className="auth-subtitle">
            Enter your email address and we will send you a link to reset your password.
          </p>
        </header>

        <form className="auth-form" onSubmit={handleSubmit}>
          <InputField
            id="email"
            type="email"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <FormError message={error} />

          <Button
            type="submit"
            className="auth-button"
            disabled={loading}
            loading={loading}
            loadingText="Please wait…"
          >
            Send Link
          </Button>
        </form>

        <footer className="auth-footer">
          Back to{" "}
          <Link to="/login">
            Login
          </Link>
        </footer>
      </FormContainer>
    </main>
  );
};

export default ForgotPassword;

